export default "__VITE_ASSET__28OVazzI__"